<div class="flex gap-1.5 flex-wrap">
  @if (tags() && tags().length) {
    @for (item of tags(); track $index) {
      @let backgroundColor = item.color ?? getDefaultColor(item.name);
      <div class="px-2 py-0.5 rounded-full font-bold whitespace-nowrap" [title]="item.name"
           [ngStyle]="{background: backgroundColor, color: getTextColor(backgroundColor)}">
        {{ item.name }}
      </div>
    }
  } @else {
    <div class="label-content">--</div>
  }
</div>
